export default __webpack_public_path__ + "static/media/Collecting.feed2828.svg";